module.exports = __webpack_public_path__ + "img/ic-help-toc-hat.54f59d48.svg";